module.exports = __webpack_public_path__ + "img/Date.895ab3f0.svg";